import {ReactElement, useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {IStore} from "@/redux/defaultStore";
import IndustryPassPromoModal from "@/components/modals/IndustryPassPromoModal";
import {useLocation} from "react-router";

function IndustryPassPromoHandler(): ReactElement {
    const accountLevel = useSelector((store: IStore) => store.metaStore.accountLevel);

    const [
        showModal,
        setShowModal,
    ] = useState<boolean>(false);

    // only show the modal where it makes sense - GoVIP and restaurants search page
    const location = useLocation();
    const routes: Array<string> = [
        "restaurants/search",
        "go-vip-dashboard",
    ];

    function toggleModal(): void {
        setShowModal(false);
    }

    function isRouteIncluded(): boolean {
        const isIncluded = routes.filter((route) => location.pathname.includes(route));
        return isIncluded.length > 0;
    }

    function isModalActive() {
        // Industry Pass modal is currently disabled
        return false;

        /*
         * Original logic preserved for future use:
         * if (!fullToken || !accountLevel) {
         *     return false;
         * }
         * if (accountLevel?.userOwnsIndustryCollectionNft) {
         *     return false;
         * }
         * return isRouteIncluded() && !isDismissedDuringLogin && !isDismissedForSession && dpayStatus;
         */
    }

    useEffect(() => {
        if (isModalActive()) {
            setShowModal(true);
        }
    }, [
        location.pathname,
        accountLevel,
    ]);

    return (
        <IndustryPassPromoModal
            isOpen={showModal}
            toggle={toggleModal}
        />
    );
}

export default IndustryPassPromoHandler;
